// import that from '../main';
import $http from "./http";

//登录
export const getAccountList = data => {
    return $http.post("/collect/account/list", data);
};
//获取电价名称列表
export const getPriceNamelist = data => {
    return $http.post("/collect/account/getPriceNamelist", data);
};
//获取采集点列表
export const getPointsList = data => {
    return $http.post("/collect/account/getPointsList", data);
};
//获取公司列表
export const getCustomerList = data => {
    return $http.post("/collect/common/getCustomerList", data);
};
//获取电价等级列表
export const getCodelistByKind = data => {
    return $http.post("/collect/common/getCodelistByKind", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
//删除
export const delDemoInfo = data => {
    return $http.post("/collect/account/del", data);
};
//修改
export const getInfoById = data => {
    return $http.post("/collect/account/getInfoById", data);
};

//获取容量列表
export const getCapacitylist = data => {
    return $http.post("/collect/account/getCapacitylist", data);
};
//获取保存户号
export const saveAccount = data => {
    return $http.post("/collect/account/save", data);
};
//保存容量
export const capacityFormSave = data => {
    return $http.post("/collect/account/capacityFormSave", data, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
//-------------设备入库
//获取设备入库列表
export const getfindCollectoByFactoryNo = data => {
    return $http.post("/collect/collector/getCollectorList", data);
};
//新增
export const addCollector = data => {
    return $http.post("/collect/collector/addCollector", data);
};
//删除
export const deleteCollector = data => {
    return $http.post("/collect/collector/deleteCollector", data);
};
//修改
export const getCollectorInfo = data => {
    return $http.post("/collect/collector/getCollectorInfo", data);
};

//虚点设置
//虚点设置列表
export const getPointTree = data => {
    return $http.post("/collect/common/getPointList", data);
};
//虚点设置列表
export const getimaginaryPointList = data => {
    return $http.post("/collect/imaginaryPoint/list", data);
};
//保存虚点列表
export const getimaginaryPointSave = data => {
    return $http.post("/collect/imaginaryPoint/save", data);
};
//删除虚点列表
export const getimaginaryPointdel = data => {
    return $http.post("/collect/imaginaryPoint/del", data);
};

//功率因数
export const getFactorByPointId = data => {
    return $http.post("/collect/needAnalysis/getFactorByPointId", data);
};
//变压器负载
export const getTransformerRateByPointId = data => {
    return $http.post(
        "/collect/needAnalysis/getTransformerRateByPointId",
        data
    );
};
//采集异常
export const getAbnormalList = data => {
    return $http.post("/collect/abnormal/getAbnormalList", data);
};
// 获取采集点
export const getUnitPointList = data => {
    return $http.post("/collect/common/getUnitPointList", data);
};
// 获取变压器
export const getTransformerList = data => {
    return $http.post("/collect/common/getTransformerList", data);
};
// 获取用户统计列表 -- 微网监控
export const getUserTotal = data => {
    return $http.post("/collect/user_total/getUserTotal", data);
};

// 获取用户统计列表
export const getUserTotalCount = data => {
    return $http.post("/collect/user_total/getUserTotalCount", data);
};

// 获取用户统计列表 -- 能耗分析
export const getEnergyUserTotal = data => {
    return $http.post("/collect/user_total/getEnergyUserTotal", data);
};
